import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WeeklyPlanSection } from '../components/WeeklyPlanSection';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { StickyBar } from '../components/StickyBar';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-stone-50 font-sans text-slate-900" data-id="element-201">
      {/* Header/Nav - Simple Logo */}
      <header className="bg-white py-4 shadow-sm sticky top-0 z-40" data-id="element-202">
        <div className="container mx-auto px-4 flex justify-center md:justify-start" data-id="element-203">
          <span className="text-xl font-serif font-bold text-emerald-800 tracking-tight" data-id="element-204">
            Rodillas<span className="text-amber-500" data-id="element-205">Jóvenes</span>
          </span>
        </div>
      </header>

      <main data-id="element-206">
        <HeroSection data-id="element-207" />
        <ProblemSection data-id="element-208" />
        <SolutionSection data-id="element-209" />
        <WeeklyPlanSection data-id="element-210" />
        <BonusSection data-id="element-211" />
        <TestimonialsSection data-id="element-212" />
        <CTASection data-id="element-213" />
      </main>

      <Footer data-id="element-214" />

      <StickyBar data-id="element-215" />
    </div>;
}